import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static w1b() {
        NoOpEncoder_instance = null;
        var $this = this.d14();
        NoOpEncoder_instance = $this;
        $this.v1b_1 = EmptySerializersModule();
        return $this;
      }
      mz() {
        return this.v1b_1;
      }
      f14(value) {
        return Unit_instance;
      }
      g14() {
        return Unit_instance;
      }
      h14(value) {
        return Unit_instance;
      }
      i14(value) {
        return Unit_instance;
      }
      j14(value) {
        return Unit_instance;
      }
      k14(value) {
        return Unit_instance;
      }
      l14(value) {
        return Unit_instance;
      }
      m14(value) {
        return Unit_instance;
      }
      n14(value) {
        return Unit_instance;
      }
      o14(value) {
        return Unit_instance;
      }
      p14(value) {
        return Unit_instance;
      }
      q14(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().w1b();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstance3if0k9o02xdwe,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
